export const configActionTypes = {
  setPartnerLocationIds: "SET_PARTNER_LOCATION_IDS",
  setPartnerName: "SET_PARTNER_NAME",
  setLanguage: "SET_LANGUAGE",
  setMode: "SET_MODE",
  setTheme: "SET_THEME",
  updateLaunchContext: "UPDATE_LAUNCH_CONTEXT"
};
